// extracted by mini-css-extract-plugin
export default {"legalNotice":"_52VjROnMYDb2zU6K5O49Qf"};